import React, { ForwardedRef } from 'react';
import { PressResponder } from '@react-aria/interactions';
import { Button } from '../../../Button';
import { TabProps, TabsSize } from '../TabsProps';
import { FocusableElement } from '@react-types/shared';

export type ButtonTabBaseProps = TabProps & { size?: TabsSize };

export const ButtonTabBase = React.forwardRef(function ButtonTabBase(
  {
    isDisabled,
    isActive,
    children,
    href,
    onClick,
    size = 'md',
    ...props
  }: ButtonTabBaseProps,
  ref: ForwardedRef<HTMLDivElement | HTMLAnchorElement>
): JSX.Element {
  const tabButtonProps = {
    ...props,
    onClick: isDisabled
      ? undefined
      : (onClick as React.MouseEventHandler<FocusableElement>),
  };

  return (
    <PressResponder ref={ref} {...tabButtonProps}>
      <Button
        size={size}
        isDisabled={isDisabled}
        variant={isActive ? 'primary' : 'secondary'}
        // @ts-expect-error: In safari, on tabbing the tab is focused if the element is div and not button.
        // TODO: Update Button component to support element type of 'div': UC-1804
        elementType={href ? 'a' : 'div'}
        href={isDisabled ? undefined : href}
      >
        {children}
      </Button>
    </PressResponder>
  );
});
